import { useMemo } from "react";
import { Controller, useFormContext } from "react-hook-form";
import { useSelector } from "react-redux";

import Select from "../components/Select";
import { ChoiceGroup, Field } from "./fields";
import { GENDER, RESIDENCY } from "./steps";

// The nationality list is already fetched for every visitor in AppRouter.
export function useNationalities() {
  const { nationality = [], nationalityLoading } = useSelector((state) => state.common);
  const options = useMemo(
    () =>
      [...(nationality || [])]
        .filter((n) => n?.name)
        .sort((a, b) => a.name.localeCompare(b.name)),
    [nationality],
  );
  return { options, loading: nationalityLoading };
}

function NationalityField() {
  const {
    control,
    formState: { errors },
  } = useFormContext();
  const { options, loading } = useNationalities();
  const items = useMemo(
    () => options.map((n) => ({ value: String(n.id), label: n.name })),
    [options],
  );

  return (
    <Field label="Nationality" error={errors.nationality?.message} className="cr-span-2">
      {({ id, describedBy, invalid }) => (
        <Controller
          name="nationality"
          control={control}
          rules={{ required: "Choose your nationality" }}
          render={({ field }) => (
            <Select
              id={id}
              title="Nationality"
              searchable
              searchPlaceholder="Search nationality"
              placeholder={loading && !items.length ? "Loading…" : "Choose your nationality"}
              disabled={loading && !items.length}
              options={items}
              value={field.value ? String(field.value) : ""}
              onChange={(v) => {
                field.onChange(v);
                field.onBlur();
              }}
              invalid={invalid}
              describedBy={describedBy}
            />
          )}
        />
      )}
    </Field>
  );
}

function ChoiceField({ name, legend, options, message, columns }) {
  const {
    control,
    formState: { errors },
  } = useFormContext();
  return (
    <Controller
      name={name}
      control={control}
      rules={{ required: message }}
      render={({ field }) => (
        <ChoiceGroup
          className="cr-span-2"
          legend={legend}
          name={name}
          options={options}
          value={field.value}
          onChange={field.onChange}
          error={errors[name]?.message}
          columns={columns}
        />
      )}
    />
  );
}

export default function AboutStep() {
  return (
    <div className="cr-fields">
      <NationalityField />
      <ChoiceField
        name="residence_status"
        legend="Your UAE residency"
        options={RESIDENCY}
        message="Choose your residency status"
        columns={2}
      />
      <ChoiceField name="gender" legend="Gender" options={GENDER} message="Choose one" columns={2} />
    </div>
  );
}
